import Lang from "@/lang";
import { mapGeography } from "@/settings/charts/mapGeography";
import { defaultColorSet } from "@/settings/colors";
import dimensionMetrics from "@/settings/metrics/dimensionMetrics";
import displayMetrics, { advertisersMetrics } from "@/settings/metrics/displayMetrics";
import timeMetrics from "@/settings/metrics/timeMetrics";
import { tableRows } from "@/settings/tableSettings";
import { InputDictionary } from "@/types/common";

export default <Record<string, InputDictionary[]>>{
  legendPositions: [
    { title: Lang.bottom, value: "bottom" },
    { title: Lang.top, value: "top" },
    { title: Lang.left, value: "left" },
    { title: Lang.right, value: "right" },
  ],
  frequency: [
    { title: Lang.year, value: "year" },
    { title: Lang.quarter, value: "quarter" },
    { title: Lang.month, value: "month" },
    { title: Lang.week, value: "week" },
    { title: Lang.date, value: "date" },
  ],

  summaryTrendOptions: [
    { title: Lang.periodOverPeriod, value: "pop" },
    { title: Lang.yearOverYear, value: "yoy" },
  ],

  mapGeographyTypes: [
    { title: Lang.states, value: mapGeography.states },
    { title: Lang.dma, value: mapGeography.dma },
  ],

  colors: defaultColorSet.map((value) => ({ title: value, value })),

  percents: [
    { title: "10%", value: 10 },
    { title: "20%", value: 20 },
    { title: "30%", value: 30 },
    { title: "40%", value: 40 },
    { title: "50%", value: 50 },
    { title: "60%", value: 60 },
    { title: "70%", value: 70 },
    { title: "80%", value: 80 },
    { title: "90%", value: 90 },
  ],

  pieScales: [
    { title: "100%", value: 100 },
    { title: "75%", value: 75 },
    { title: "50%", value: 50 },
    { title: "25%", value: 25 },
  ],

  lineThickness: [
    { title: "1", value: 1 },
    { title: "2", value: 2 },
    { title: "3", value: 3 },
    { title: "4", value: 5 },
  ],

  waffleBricks: [
    { title: "4", value: 4 },
    { title: "8", value: 8 },
    { title: "16", value: 16 },
    { title: "32", value: 32 },
  ],

  showItems: [
    { title: Lang.all, value: null },
    { title: Lang.top5, value: 5 },
    { title: Lang.top8, value: 8 },
    { title: Lang.top10, value: 10 },
  ],

  dimensionMetrics,
  displayMetrics,
  nullableDisplayMetrics: [
    {
      title: "",
      value: null,
    },
    ...displayMetrics,
  ],
  timeMetrics,
  advertisersMetrics,
  summaryMetrics: displayMetrics,
  tableRows,
};
